if (!customElements.get('up12-hero')) {
  customElements.define('up12-hero', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.slides = [...this.querySelectorAll('[data-up12-slide]')];
      if (!this.slides.length) return;
      this.index = 0;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.reducedMotion.matches;
      this.visible = true;
      this.hovered = false;
      this.focused = false;
      this.controls = this.querySelector('.slideshow-controls');
      this.controls.hidden = this.slides.length < 2;
      this.querySelector('[data-study-prev]').addEventListener('click', () => this.move(-1, true), { signal });
      this.querySelector('[data-study-next]').addEventListener('click', () => this.move(1, true), { signal });
      this.querySelector('[data-study-pause]').addEventListener('click', () => {
        this.paused = !this.paused;
        this.update();
      }, { signal });
      this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, { signal });
      this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, { signal });
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, { signal });
      this.addEventListener('focusout', () => queueMicrotask(() => { this.focused = this.contains(document.activeElement); this.schedule(); }), { signal });
      document.addEventListener('visibilitychange', () => this.schedule(), { signal });
      this.reducedMotion.addEventListener('change', () => {
        if (this.reducedMotion.matches) this.paused = true;
        this.update();
      }, { signal });
      document.addEventListener('shopify:block:select', event => {
        const slide = event.target.closest('[data-up12-slide]');
        if (!this.slides.includes(slide)) return;
        this.index = this.slides.indexOf(slide);
        this.paused = true;
        this.update();
      }, { signal });
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.schedule();
      });
      this.observer.observe(this);
      this.update();
    }
    move(delta, manual = false) {
      this.index = (this.index + delta + this.slides.length) % this.slides.length;
      if (manual) this.paused = true;
      this.update();
    }
    update() {
      this.slides.forEach((slide, index) => { slide.hidden = index !== this.index; });
      const slide = this.slides[this.index];
      this.querySelector('[data-study-number]').textContent = String(this.index + 1).padStart(2, '0');
      this.querySelector('[data-study-audience]').textContent = slide.dataset.audience;
      this.querySelector('[data-study-description]').textContent = slide.dataset.description;
      this.querySelector('[data-study-count]').textContent = `${this.index + 1} / ${this.slides.length}`;
      const pause = this.querySelector('[data-study-pause]');
      pause.textContent = this.paused ? this.dataset.play : this.dataset.pause;
      pause.setAttribute('aria-pressed', String(this.paused));
      this.schedule();
    }
    schedule() {
      clearInterval(this.timer);
      if (!this.paused && this.visible && !this.hovered && !this.focused && !document.hidden && this.slides.length > 1) {
        this.timer = setInterval(() => this.move(1), 3000);
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      clearInterval(this.timer);
    }
  });
}

if (!window.up12NavigationReady) {
  window.up12NavigationReady = true;
  document.addEventListener('click', event => {
    const link = event.target.closest('.up12-mobile-nav a');
    if (link) link.closest('details').open = false;
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const openMenu = document.querySelector('.up12-mobile-menu[open]');
    if (!openMenu) return;
    openMenu.open = false;
    openMenu.querySelector('summary').focus();
  });
}
